"use strict";
exports.__esModule = true;
exports.IX_TITLES = exports.IX_STRUCTS = exports.AssociatedTokenAccountInstructionType = exports.AssociateInfo = void 0;
var superstruct_1 = require("superstruct");
var pubkey_1 = require("../../validators/pubkey");
exports.AssociateInfo = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    mint: pubkey_1.PublicKeyFromString,
    wallet: pubkey_1.PublicKeyFromString
});
// not a real instruction type, added for structure
exports.AssociatedTokenAccountInstructionType = (0, superstruct_1.enums)(["associate"]);
exports.IX_STRUCTS = {
    associate: exports.AssociateInfo
};
exports.IX_TITLES = {
    associate: "Associate"
};
//# sourceMappingURL=types.js.map